export { loadTranslation, getTranslation, DEFAULT_LOCALE } from '../src/translation.ts';
